import { render, staticRenderFns } from "./VImage.vue?vue&type=template&id=1f4439ba&scoped=true&"
import script from "./VImage.vue?vue&type=script&lang=js&"
export * from "./VImage.vue?vue&type=script&lang=js&"
import style0 from "./VImage.vue?vue&type=style&index=0&id=1f4439ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4439ba",
  null
  
)

export default component.exports